import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  ehMobile: boolean = false;

  constructor() { }

  ngOnInit(): void {
    if (window.screen.width < 550)
      this.ehMobile = true;   
  }
}
